import { GOOGLE_DRIVE } from './AppCard/GoogleDriveCard/Config';
import { QUICKBOOKS } from './AppCard/QuickbookCard/Config';

export const APP_LIST = [QUICKBOOKS, GOOGLE_DRIVE];
